export default __webpack_public_path__ + "9c0f9a5a82cbf15789b0608e99413d15.svg";